<template>
  <WhitePage>
    <title-bar>Special Thanks</title-bar>
    <!-- <b-alert show variant="info">
      
    </b-alert> -->
    <b-card title="青い星の森">
      <b-img-lazy class="bg" src="./img/bg/bluestarforest.jpg" />
      <div class="description">背景（えんのしゅーし 様）</div>
    </b-card>
    <b-card title="カワアジサイが並ぶ道">
      <b-img-lazy class="bg" src="./img/bg/kawahydrangearoad.jpg" />
      <div class="description">背景（えんのしゅーし 様）</div>
    </b-card>
    <b-card title="ライオンバチの林">
      <b-img-lazy class="bg" src="./img/bg/rionbeeforest.jpg" />
      <b-img-lazy src="./img/npc/rionbee/n.jpg" />
      <div class="description">背景・ライオンバチ（シルバーミノ虫 様）</div>
    </b-card>
    <b-card title="サンドワームの砂漠">
      <b-img-lazy class="bg" src="./img/bg/sandwormdesert.jpg" />
      <b-img-lazy src="./img/npc/sandworm/n.jpg" />
      <div class="description">背景・サンドワーム（シルバーミノ虫 様）</div>
    </b-card>
    <pagenate>
      <template #previous>
        <b-icon icon="chevron-left" />
        <router-link to="/help/etc">その他</router-link>
      </template>
    </pagenate>
  </WhitePage>
</template>

<script>
// import phina from 'phina.js'
import WhitePage from '@/components/WhitePage'
import TitleBar from '@/components/TitleBar'
// import HelpNav from '@/components/HelpNav'
import Pagenate from '@/components/Pagenate'
export default {
  components: {
    WhitePage,
    TitleBar,
    // HelpNav
    Pagenate
  },
  data () {
    return {
    }
  },
  methods: {
  },
  mounted () {
    // phina.global.app.currentScene.exit('MainScene')
  }
}
</script>

<style scoped lang="scss">
.bg {
  width: 100%;
}
.description {
  font-size: small;
}
</style>
